import { render, staticRenderFns } from "./Actuallity.vue?vue&type=template&id=8fbd4de8&scoped=true&"
import script from "./Actuallity.vue?vue&type=script&lang=js&"
export * from "./Actuallity.vue?vue&type=script&lang=js&"
import style0 from "./Actuallity.vue?vue&type=style&index=0&id=8fbd4de8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbd4de8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VContainer,VProgressCircular})
